var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{style:(`background: ${_vm.$theme.background}`),attrs:{"title":_vm.$route.name,"options":_vm.options}},[_c('div',{staticClass:"expande-horizontal wrap",staticStyle:{"background":"#e2e2e2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }